import { render, staticRenderFns } from "./UserDocumentsTab.vue?vue&type=template&id=7a6e7eca&scoped=true"
import script from "./UserDocumentsTab.vue?vue&type=script&lang=js"
export * from "./UserDocumentsTab.vue?vue&type=script&lang=js"
import style0 from "./UserDocumentsTab.vue?vue&type=style&index=0&id=7a6e7eca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6e7eca",
  null
  
)

export default component.exports